<template>
    <b-card>
        <h4>Sözleşme Oluştur</h4>
        <div class="row">
                <div class="col-md-3 mb-1">
                    <label class="form-label">Sözleşme No</label>
                    <input type="text" class="form-control" v-model="Agreement.AgreementCode" placeholder="Sözleşme No" />
                </div>
                <div class="col-md-3 mb-1">
                    <label class="form-label">Sözleşme Adı</label>
                    <input type="text" class="form-control" v-model="Agreement.Name" placeholder="Sözleşme Adı" />
                </div>
                
                <div class="col-md-3 mb-1">
                    <label class="form-label">Sözleşme Başlangıç Tarihi</label>
                    <v-date-picker v-model="Agreement.StartDate"  placeholder="Sözleşme Başlangıç Tarihi"></v-date-picker>     
                </div>
                <div class="col-md-3 mb-1">
                    <label class="form-label">Sözleşme Bitiş Tarihi</label>
                    <v-date-picker v-model="Agreement.ExpireDate"  placeholder="Sözleşme Bitiş Tarihi"></v-date-picker>
                </div>
                <!-- Rotaların mazot baz tarihi. Sözleşme başlangıcından bağımsızdır: Ocak'ta
                     imzalanan sözleşmenin fiyatları Aralık mazot seviyesinde pazarlık edilmiş
                     olabilir. Excel'de satır bazında BazTarih verilmişse o önceliklidir. -->
                <div class="col-md-3 mb-1">
                    <label class="form-label">
                        Mazot Baz Tarihi
                        <small class="text-muted">(varsayılan)</small>
                    </label>
                    <v-select-list
                        v-model="fuelBase"
                        placeholder="Sözleşme başlangıç tarihi kullanılır"
                        label="Label"
                        :loading="fuelPricesLoading"
                        :options="fuelPrices"/>
                </div>
                <!-- Cari zorunlu: rota fiyatları seferlere cari üzerinden eşlendiği için
                     carisiz sözleşmenin fiyatları hiçbir sefere uygulanmaz. -->
                <div class="col-md-12 mb-1">
                    <label class="form-label">Cari <span class="text-danger">*</span></label>
                    <v-select-list :loading="cariLoading" :options="cariList"  v-on:search="getCariList" v-model="cari" placeholder="Cari" label="CARI_ISIM"></v-select-list>
                    <small v-if="!Agreement.CariCode" class="text-danger">
                        Cari seçimi zorunludur. Seçilmeden sözleşme kaydedilemez.
                    </small>
                </div>
        </div>
        <div class="row">
                <div class="col-md-3">
                    <div class="border rounded px-1 pt-1 mb-1">
                        <div class="row">
                            <div class="col-12 mb-1">
                                <b-form-checkbox disabled v-model="Agreement.AgreementPriceFactor.InflationAffectValueActive" >Fiyata Enflasyon Etki Oranı Aktif Mi?(%)</b-form-checkbox>
                            </div>
                            <template v-if="Agreement.AgreementPriceFactor.InflationAffectValueActive == true">
                                <div class="col-lg-6 mb-1">
                                    <label class="form-label">Fiyata Enflasyon Etki Oranı</label>
                                    <input class="form-control" v-model="Agreement.AgreementPriceFactor.InflationAffectValue" placeholder="0" />
                                </div>
                            </template>
                        </div>     
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="border rounded px-1 pt-1 mb-1">
                        <div class="row">
                            <div class="col-12 mb-1">
                                <b-form-checkbox disabled v-model="Agreement.AgreementPriceFactor.InflationAffectRateValueActive" >Enflasyon Oranı Aktif Mi? (%)</b-form-checkbox>
                            </div>
                            <template v-if="Agreement.AgreementPriceFactor.InflationAffectRateValueActive == true">
                                <div class="col-lg-6 mb-1">
                                    <label class="form-label">Enflasyon Oranı (%)</label>
                                    <input disabled class="form-control" v-model="Agreement.AgreementPriceFactor.InflationAffectRateValue" placeholder="0" />
                                </div>
                            </template>
                        </div>     
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="border rounded px-1 pt-1 mb-1">
                        <div class="row">
                            <div class="col-12 mb-1">
                                <b-form-checkbox disabled v-model="Agreement.AgreementPriceFactor.FuelAffectValueActive" >Fiyata Yakıt Etki Oranı Aktif Mi?</b-form-checkbox>
                            </div>
                            <template v-if="Agreement.AgreementPriceFactor.FuelAffectValueActive == true">
                                <div class="col-lg-6 mb-1">
                                    <label class="form-label">Fiyata Yakıt Etki Oranı</label>
                                    <input class="form-control" v-model="Agreement.AgreementPriceFactor.FuelAffectValue" placeholder="0" />
                                </div>
                            </template>
                        </div>     
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="border rounded px-1 pt-1 mb-1">
                        <div class="row">
                            <div class="col-12 mb-1">
                                <b-form-checkbox disabled v-model="Agreement.AgreementPriceFactor.FuelAffectRateValueActive" >Yakıt Fiyatı Artış/Azalış Oranı Aktif Mi? (%)</b-form-checkbox>
                            </div>
                            <template v-if="Agreement.AgreementPriceFactor.FuelAffectRateValueActive == true">
                                <div class="col-lg-6 mb-1">
                                    <label class="form-label">Yakıt Fiyatı Artış/Azalış Oranı (%)</label>
                                    <input class="form-control" v-model="Agreement.AgreementPriceFactor.FuelAffectRateValue" placeholder="0" />
                                </div>
                            </template>
                        </div>     
                    </div>
                </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <label class="form-label">Sözleşme</label> 
                <v-file-uploader :accept="['pdf']" v-model="Agreement" valueParameter="Document" ></v-file-uploader>
            </div>
        </div>
        <div class="border rounded p-75">
            <div class="col-12 mb-1">
                <button class="btn btn-flat-success" v-on:click="downloadSample">
                    <feather-icon icon="FileIcon"></feather-icon>
                    Örnek Excel
                </button>
            </div>
            <div class="row align-items-center">
                <div class="col-12 mb-1">
                    <label class="form-label">Excel İle Rota Ekle</label> 
                    <v-file-uploader :accept="['xlsx']" v-model="ExcelFile" valueParameter="File" ></v-file-uploader>
                </div>
                <div class="col-12 d-flex align-items-center">
                    <button :disabled="ExcelFile.File == null" class="btn btn-primary text-nowrap waves-effect d-block" v-on:click="fileUpload" >
                        <feather-icon icon="PlusIcon" size="16" class="mr-1" ></feather-icon>Excel ile Rota Ekle
                    </button>
                </div>
            </div>
        </div>
        <div class="row mt-1" v-if="InvalidRoutes.length>0">
            <div class="col-12">
                <h3 class="font-weight-bolder">Geçersiz Bilgi İçeren Kayıtlar:</h3>
                <table class="table table-sm table-bordered align-middle ">
                    <thead>
                        <tr>
                            <th class="w-10 text-nowrap">Başlangıç Bölge Kodu</th>
                            <th class="w-10 text-nowrap">Bitiş Bölge Kodu</th>
                            <th class="w-10 text-nowrap">Araç Tipi Kodu</th>
                            <th class="w-10 text-nowrap">Ürün Tipi Kodu</th>
                            <th class="w-10 text-nowrap">Taşıma Tipi</th>
                            <th class="w-10 text-nowrap">Fiyat</th>
                            <th class="w-40 text-nowrap">Hatalar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(data) in InvalidRoutes">
                            <tr :key="data.Id">
                                <td v-if="data.BaslangicBolgeKodu != null">{{ data.BaslangicBolgeKodu }}</td>
                                <td v-if="data.BitisBolgeKodu != null">{{ data.BitisBolgeKodu }}</td>
                                <td v-if="data.AracTipiKodu != null">{{ data.AracTipiKodu }}</td>
                                <td class="text-nowrap" v-if="data.TasinanUrunStokKodu != null">{{data.TasinanUrunStokKodu}}</td>
                                <td v-if="data.TasimaDurumu != null">{{ data.TasimaDurumu }}</td>
                                <td v-if="data.Fiyat != null" class="text-right">{{ data.Fiyat }} ₺</td>
                                <td v-if="data.Errors.length>0" class="bg-light-danger p-50">
                                    <ul class="list-group">
                                        <li class="list-group-item" v-for="(x,index) in data.Errors" :key="index">{{x}}</li>
                                    </ul>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <br/>
        <div class="row mb-2" v-if="NullValueRoutes.length>0">
            <div class="col-12">
                <h3 class="font-weight-bolder">Boş Değer İçeren Kayıtlar:</h3>
                <table class="table table-sm table-bordered align-middle ">
                    <thead>
                        <tr>
                            <th class="w-18 text-nowrap">Başlangıç Bölge Kodu</th>
                            <th class="w-18 text-nowrap">Bitiş Bölge Kodu</th>
                            <th class="w-18 text-nowrap">Araç Tipi Kodu</th>
                            <th class="w-18 text-nowrap">Ürün Tipi Kodu</th>
                            <th class="w-18 text-nowrap">Taşıma Tipi</th>
                            <th class="w-10 text-nowrap">Fiyat</th>
                        </tr>
                    </thead>
                    <tbody class="">
                        <template v-for="(data) in NullValueRoutes">
                            <tr :key="data.Id">
                                <td v-if="data.BaslangicBolgeKodu != null">{{ data.BaslangicBolgeKodu }}</td>
                                <td v-if="data.BaslangicBolgeKodu == null" class="bg-light-danger">DEĞER YOK</td>
                                
                                <td  v-if="data.BitisBolgeKodu != null">{{ data.BitisBolgeKodu }}</td>
                                <td  v-if="data.BitisBolgeKodu == null" class="bg-light-danger">DEĞER YOK</td>

                                <td v-if="data.AracTipiKodu != null">{{ data.AracTipiKodu }}</td>
                                <td v-if="data.AracTipiKodu == null" class="bg-light-danger">DEĞER YOK</td>

                                <td class="text-nowrap" v-if="data.TasinanUrunStokKodu != null">{{data.TasinanUrunStokKodu}}</td>
                                <td class="text-nowrap bg-light-danger" v-if="data.TasinanUrunStokKodu == null">DEĞER YOK</td>

                                <td v-if="data.TasimaDurumu != null">{{ data.TasimaDurumu }}</td>
                                <td v-if="data.TasimaDurumu == null" class="bg-light-danger">DEĞER YOK</td>

                                <td v-if="data.Fiyat != null" class="text-right">{{ data.Fiyat }} ₺</td>
                                <td v-if="data.Fiyat == null" class="text-right bg-light-danger">DEĞER YOK</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-auto mb-1 mb-md-0">
                <button class="btn btn-primary text-nowrap waves-effect" v-on:click="createRoute" >
                    <feather-icon icon="PlusIcon" size="16" ></feather-icon>
                    Rota Ekle
                </button>
            </div>

            <!-- Zorunlu alanlar seçilmeden rota eklenemez: eksik bölge/araç tipi sunucuda
                 yabancı anahtar hatasına dönüşüp kaydı komple engelliyordu. -->
            <b-modal id="create-route" title="Rota Oluştur" no-close-on-esc no-close-on-backdrop>
                <create-agreement-route v-model="agreementRoutePrice"></create-agreement-route>
                <b-alert v-if="newRouteValidationMessage" show variant="warning" class="p-1 mb-0 mt-1">
                    <small>{{ newRouteValidationMessage }}</small>
                </b-alert>
                <template #modal-footer>
                    <v-executer :disabled="newRouteValidationMessage != null" :action="addRoute"></v-executer>
                </template>
            </b-modal>

        </div>
        <div class="row mt-2" v-if="Agreement.AgreementRoutePrices.length>0">
            <div class="col-12">
                <h3 class="font-weight-bolder">Rotalar:</h3>
                <div class="table-responsive">
                    <table class="table table-sm table-bordered align-middle">
                        <thead>
                            <tr>
                                <th>İşlemler</th>
                                <th class="w-16">Başlangıç Bölgesi</th>
                                <th class="w-16">Bitiş Bölgesi</th>
                                <th class="w-16">Araç Tipi</th>
                                <th class="w-16 text-nowrap">Ürün Tipi</th>
                                <th class="w-16">Taşıma Tipi</th>
                                <th class="w-16 text-nowrap">Baz Tarih</th>
                                <th class="w-20">Fiyat</th>
                                <th class="w-20 text-nowrap">Güncel Fiyat</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(data,index) in Agreement.AgreementRoutePrices">
                                <!-- Eksik zorunlu alanı olan satır kaydı komple engellediği için
                                     listede ayırt edilebilir olmalı. -->
                                <tr :key="index" :class="{'table-danger': isRouteIncomplete(data)}">
                                    <td>
                                        <b-dropdown dropright size="sm" variant="light" no-caret>
                                            <template #button-content>
                                                <feather-icon class="mr-50" icon="MoreHorizontalIcon"></feather-icon>
                                                İşlemler
                                            </template>    
                                            <b-dropdown-item  variant="danger"  v-on:click="deleteRoute(index)">
                                                <feather-icon class="mr-50" icon="TrashIcon" size="16" ></feather-icon>
                                                Sil
                                            </b-dropdown-item> 
                                        </b-dropdown>
                                    </td>
                                    <td>
                                        <span v-if="data.StartRegionId">{{ data.StartRegionName }}</span>
                                        <small v-else class="text-danger font-weight-bolder">seçilmemiş</small>
                                    </td>
                                    <td>
                                        <span v-if="data.EndRegionId">{{ data.EndRegionName }}</span>
                                        <small v-else class="text-danger font-weight-bolder">seçilmemiş</small>
                                    </td>
                                    <td>
                                        <span v-if="data.VehicleTypeId">{{ data.VehicleTypeName }}</span>
                                        <small v-else class="text-danger font-weight-bolder">seçilmemiş</small>
                                    </td>
                                    <td class="text-nowrap">
                                        <span v-if="data.StockCode">{{ data.StockName }}</span>
                                        <small v-else class="text-danger font-weight-bolder">seçilmemiş</small>
                                    </td>
                                    <td>{{ data.VehicleTransportStatusName }}</td>
                                    <td class="text-nowrap">
                                        <span v-if="data.FuelBaseDateStr">{{ data.FuelBaseDateStr }}</span>
                                        <small v-else class="text-muted">varsayılan</small>
                                    </td>
                                    <td class="text-right">{{ data.Price }} ₺</td>
                                    <td class="text-right text-nowrap">
                                        <template v-if="simulationByRow[index]">
                                            <span v-if="simulationByRow[index].ErrorMessage" class="text-danger">
                                                <small>{{ simulationByRow[index].ErrorMessage }}</small>
                                            </span>
                                            <template v-else>
                                                <b>{{ simulationByRow[index].Escalation.FinalPriceStr }} ₺</b>
                                                <button
                                                    v-if="simulationByRow[index].Escalation.Steps.length"
                                                    class="btn btn-link btn-sm p-0 d-block ml-auto"
                                                    v-on:click="toggleSteps(index)">
                                                    <small>
                                                        {{ simulationByRow[index].Escalation.Steps.length }} ara zam
                                                        ({{ simulationByRow[index].Escalation.TotalChangeRateStr }})
                                                        <feather-icon
                                                            :icon="isExpanded(index) ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                                                            size="12"></feather-icon>
                                                    </small>
                                                </button>
                                            </template>
                                        </template>
                                        <small v-else class="text-muted">-</small>
                                    </td>
                                </tr>
                                <!-- Ara zam detayı: baz tarihten bugüne hangi günde hangi
                                     mazot değişimiyle hangi zammın oluştuğu. -->
                                <tr v-if="isExpanded(index) && simulationByRow[index] && simulationByRow[index].Escalation" :key="index + '-steps'">
                                    <td colspan="100" class="bg-light p-1">
                                        <small class="text-muted d-block mb-50">
                                            {{ data.StartRegionName }} → {{ data.EndRegionName }} ·
                                            baz {{ simulationByRow[index].Escalation.BaseDateStr }}
                                            ({{ simulationByRow[index].Escalation.BaseFuelPriceStr }} ₺) ·
                                            girilen fiyat {{ simulationByRow[index].Escalation.StartPriceStr }} ₺
                                        </small>
                                        <table class="table table-sm table-bordered bg-white mb-0">
                                            <thead>
                                                <tr>
                                                    <th class="text-nowrap">Tarih</th>
                                                    <th class="text-nowrap text-right">Mazot</th>
                                                    <th class="text-nowrap text-right">Değişim</th>
                                                    <th class="text-nowrap text-right">Eski Fiyat</th>
                                                    <th class="text-nowrap text-right">Yeni Fiyat</th>
                                                    <th class="text-nowrap text-right">Fark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(s,si) in simulationByRow[index].Escalation.Steps" :key="si">
                                                    <td class="text-nowrap">{{ s.DateStr }}</td>
                                                    <td class="text-nowrap text-right">{{ s.PreviousFuelPriceStr }} → {{ s.FuelPriceStr }}</td>
                                                    <td class="text-nowrap text-right">{{ s.FuelChangeRateStr }}</td>
                                                    <td class="text-nowrap text-right">{{ s.OldPriceStr }}</td>
                                                    <td class="text-nowrap text-right font-weight-bolder">{{ s.NewPriceStr }}</td>
                                                    <td class="text-nowrap text-right">{{ s.PriceDeltaStr }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Kaydetmeden önce ne yazılacağının görünmesi: geriye dönük ara zamlar sessizce
             oluşmasın diye toplam satır sayısı ve fiyat farkı burada özetlenir. -->
        <div class="row" v-if="simulation">
            <div class="col-12">
                <b-alert show variant="info" class="p-1">
                    <div class="d-flex flex-wrap justify-content-between align-items-center">
                        <div>
                            <b>{{ simulation.RouteCount }}</b> rota ·
                            <b>{{ simulation.TotalStepCount }}</b> geriye dönük ara zam ·
                            kaydedildiğinde toplam <b>{{ simulation.TotalRowCount }}</b> fiyat satırı yazılacak
                        </div>
                        <div>
                            Toplam: {{ simulation.TotalStartPriceStr }} ₺ →
                            <b>{{ simulation.TotalFinalPriceStr }} ₺</b>
                        </div>
                    </div>
                </b-alert>
            </div>
        </div>
        <div class="row justify-content-end" v-if="Agreement.AgreementRoutePrices.length>0">
            <div class="col-auto mb-1 mb-md-0">
                <v-executer
                    variant="primary"
                    :action="simulateRoutes"
                    :loading="simulating">
                    <feather-icon icon="ActivityIcon" size="16" class="mr-50"></feather-icon>
                    Güncel Fiyatları Hesapla
                </v-executer>
            </div>
            <div class="col-auto mb-1 mb-md-0">
                <button :disabled="saveValidationMessage != null" :title="saveValidationMessage || ''" class="btn btn-success text-nowrap waves-effect" v-on:click="createAgreement" >
                    <feather-icon icon="PlusIcon" size="16" ></feather-icon>
                    Sözleşmeyi Kaydet
                </button>
            </div>
            <div v-if="saveValidationMessage" class="col-12 mt-1">
                <b-alert show variant="warning" class="p-1 mb-0">
                    <small>{{ saveValidationMessage }}</small>
                </b-alert>
            </div>
        </div>
    </b-card>
</template>
<script>
import {BCard,BFormCheckbox,BDropdown,BDropdownItem,BAlert} from 'bootstrap-vue'
import {FuelPriceApi} from '@/api/fuel-price'
import VExecuter from '@/components/VExecuter.vue'
import moment from 'moment'
import {FirmApi} from '@/api/firm'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import CreateAgreementRoute from './components/CreateAgreementRoute.vue'
import { AgreementApi } from '@/api/agreement'
import { NetsisApi } from '@/api/netsis'
import Additional from '@/utilities/additional'
import { parse } from 'uuid'
export default {
    components:{
        BDropdown,
        BDropdownItem,
        BCard,
        BFormCheckbox,
        CreateAgreementRoute,
        VFileUploader,
        VExecuter,
        BAlert
    },
    data(){
        return {
            ExcelFile:{
                File:null
            },
            InvalidRoutes:[],
            NullValueRoutes:[],
            fuelPrices:[],
            fuelPricesLoading:false,
            simulation:null,
            simulating:false,
            expandedRows:[],
            Agreement:{
                Document:null,
                CariCode:null,
                CariName:null,
                VehicleTypeId:null,
                AgreementCode:null,
                Name:null,
                ExpireDate:null,
                StartDate:null,
                // Rotalar için varsayılan mazot baz tarihi. Boşsa sunucu sözleşme başlangıç
                // tarihini kullanır; Excel'de satır bazında verilen BazTarih önceliklidir.
                FuelBaseDate:null,
                AgreementRoutePrices:[],
                AgreementPriceFactor:{
                    InflationAffectValue:null,
                    InflationAffectValueActive:true,
                    FuelAffectValue:null,
                    FuelAffectValueActive:true,
                    FuelAffectRateValue:null,
                    FuelAffectRateValueActive:true,
                    InflationAffectRateValueActive:true,
                    InflationAffectRateValue:0
                }
            },
            
            cariList:[],
            cariLoading:false,
            agreementRoutePrice:{
                VehicleTypeId:null,
                VehicleTypeName:null,
                StartRegionId:null,
                StartRegionName:null,
                EndRegionId:null,
                EndRegionName:null,
                Price:null,
                MaterialId:null,
                MaterialName:null,
                VehicleTransportStatus:null,
                VehicleTransportStatusName:null
            },
 
        }
    },
    mounted(){
        this.getFuelPrices()
    },
    watch:{
        // Rota listesi ya da baz tarih değiştiğinde önceki hesap geçersizdir; kullanıcı
        // eski sonuca bakarak kaydetmesin.
        'Agreement.AgreementRoutePrices'(){
            this.simulation = null
            this.expandedRows = []
        },
        'Agreement.FuelBaseDate'(){
            this.simulation = null
            this.expandedRows = []
        },
        'Agreement.StartDate'(){
            this.simulation = null
            this.expandedRows = []
        }
    },
    methods:{
        deleteRoute(index){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem sözleşme rotasını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    this.$delete(this.Agreement.AgreementRoutePrices,index)
                }
            })
        },
        downloadSample(){
            AgreementApi.DownloadSampleFile().then(res=>{
                Additional.DownloadFile(res.data, 'Sözleşme Rota Şablonu.xlsx')
            })
        },
        toggleSteps(key){
            const index = this.expandedRows.indexOf(key)
            if(index >= 0)
                this.expandedRows.splice(index,1)
            else
                this.expandedRows.push(key)
        },
        isExpanded(key){
            return this.expandedRows.indexOf(key) >= 0
        },
        getFuelPrices(){
            this.fuelPricesLoading = true
            FuelPriceApi.List().then(res=>{
                this.fuelPrices = res.data.Data || []
                this.fuelPricesLoading = false
            }).catch(err=>{
                console.error(err)
                this.fuelPricesLoading = false
            })
        },
        simulateRoutes(){
            if(!this.Agreement.AgreementRoutePrices.length)
                return

            this.simulating = true
            this.simulation = null
            this.expandedRows = []
            AgreementApi.SimulateRoutes({
                DefaultFuelBaseDate: this.Agreement.FuelBaseDate || this.Agreement.StartDate,
                PriceFactor: this.Agreement.AgreementPriceFactor,
                Routes: this.Agreement.AgreementRoutePrices.map((r,i) => ({
                    RowKey: String(i),
                    StartRegionName: r.StartRegionName,
                    EndRegionName: r.EndRegionName,
                    StockCode: r.StockCode,
                    VehicleTypeName: r.VehicleTypeName,
                    Price: this.parsePrice(r),
                    FuelBaseDate: r.FuelBaseDate || null
                }))
            }).then(res=>{
                if(res.data.Success)
                    this.simulation = res.data.Data
                else
                    this.$result(res)
                this.simulating = false
            }).catch(err=>{
                this.$result(null,err)
                this.simulating = false
            })
        },
        // Excel'den gelen satırlarda sayısal değer PriceValue alanındadır; Price yalnızca
        // gösterim metnidir ("1.000,00"). Elle eklenen satırlarda Price zaten sayıdır.
        // Metin kalan durumlarda ayrıştırma Additional.ParseDecimal'a bırakılır: burada
        // bütün noktalar binlik sayılıp siliniyordu ve "722.94" girişi 72294 oluyordu.
        parsePrice(route){
            if(route == null) return 0
            if(typeof route.PriceValue === 'number') return route.PriceValue
            if(typeof route.Price === 'number') return route.Price
            return Additional.ParseDecimal(route.Price) || 0
        },
        // Rotanın sunucuya gönderilebilmesi için gereken zorunlu referanslar. Biri eksikse
        // model binding onu Guid.Empty yapıyor ve kayıt yabancı anahtar hatasına düşüyor.
        isRouteIncomplete(route){
            if(route == null) return true
            return !route.StartRegionId
                || !route.EndRegionId
                || !route.VehicleTypeId
                || !route.StockCode
                || !(this.parsePrice(route) > 0)
        },
        addRoute(){
            if(this.newRouteValidationMessage != null)
                return
            this.Agreement.AgreementRoutePrices.push({
                VehicleTypeId: this.agreementRoutePrice.VehicleTypeId,
                VehicleTypeName: this.agreementRoutePrice.VehicleTypeName,
                StartRegionId: this.agreementRoutePrice.StartRegionId,
                StartRegionName: this.agreementRoutePrice.StartRegionName,
                EndRegionId: this.agreementRoutePrice.EndRegionId,
                EndRegionName: this.agreementRoutePrice.EndRegionName,
                Price:this.agreementRoutePrice.Price,
                StockCode:this.agreementRoutePrice.StockCode,
                StockName:this.agreementRoutePrice.StockName,
                VehicleTransportStatus: this.agreementRoutePrice.VehicleTransportStatus,
                VehicleTransportStatusName: this.agreementRoutePrice.VehicleTransportStatusName
            })
            console.log(this.Agreement.AgreementRoutePrices)
            this.$hideModal('create-route')
        },
        clearForm(){
            this.agreementRoutePrice.VehicleTypeId = null
            this.agreementRoutePrice.VehicleTypeName = null
            this.agreementRoutePrice.StartRegionId = null
            this.agreementRoutePrice.StartRegionName = null
            this.agreementRoutePrice.EndRegionId = null
            this.agreementRoutePrice.EndRegionName = null
            this.agreementRoutePrice.Price = null
            this.agreementRoutePrice.StockCode = null
            this.agreementRoutePrice.StockName = null
            this.agreementRoutePrice.VehicleTransportStatus = null
            this.agreementRoutePrice.VehicleTransportStatusName = null
        },
        createRoute(){
            this.clearForm()
            this.$showModal('create-route')
        },
        getCariList(data){
            if(data){
                this.cariLoading = true
                NetsisApi.CariList(data).then(res => {
                    this.cariList = res.data.Data
                    this.cariLoading = false
                }).catch(err=> {
                    console.error(err)
                    this.cariLoading = false
                })
            }
            
        },
        // Ondalık ayırıcısı yanlış girilmiş fiyatları yakalamaya çalışır. İmza: değer büyük
        // ve kuruş kısmı tam sıfır — "722,94" yerine "722.94" yazıldığında oluşan 72294 gibi.
        // Kesin bir tespit değildir, bu yüzden engellemez; kaydetmeden önce sorar.
        suspiciousPriceRows(rows){
            const LIMIT = 10000
            return rows.filter(r => r.Price >= LIMIT && r.Price % 1 === 0)
        },
        async confirmSuspiciousPrices(rows){
            const suspicious = this.suspiciousPriceRows(rows)
            if(suspicious.length === 0)
                return true

            const sample = suspicious.slice(0,3)
                .map(r => `${r.StartRegionName} → ${r.EndRegionName}: ${r.Price.toLocaleString('tr-TR',{minimumFractionDigits:2})} ₺`)
                .join(' · ')
            const more = suspicious.length > 3 ? ` (ve ${suspicious.length - 3} satır daha)` : ''

            return await this.$confirm(
                'Fiyatlar beklenenden yüksek',
                `${suspicious.length} satırda fiyat çok yüksek ve kuruş kısmı sıfır. `
                + `Ondalık ayırıcıyı yanlış yazmış olabilirsiniz (örn. 722,94 yerine 722.94). `
                + `Örnek: ${sample}${more}. Yine de kaydedilsin mi?`,
                'Kaydet',
                'Vazgeç'
            )
        },
        async createAgreement(){
            // Excel'den gelen satırların Price alanı biçimlendirilmiş metindir ("1.224,85").
            // Sunucuya olduğu gibi gönderilirse decimal bağlaması kültüre göre yanlış çözebilir;
            // bu yüzden gönderim öncesi her satırın fiyatı sayısala normalize edilir.
            const payload = {
                ...this.Agreement,
                AgreementRoutePrices: this.Agreement.AgreementRoutePrices.map(r => ({
                    ...r,
                    Price: this.parsePrice(r)
                }))
            }

            if(!await this.confirmSuspiciousPrices(payload.AgreementRoutePrices))
                return

            let data = await Additional.ToFormData(payload)
            AgreementApi.Create(data).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.$router.push({name:'agreement'})
                }
            }).catch(err=> {
                console.error(err)
            })
        },
        async fileUpload(){
            this.Agreement.AgreementRoutePrices=[]
            this.NullValueRoutes=[]
            this.InvalidRoutes=[]
            let data = await Additional.ToFormData(this.ExcelFile)
            AgreementApi.UploadExcel(data).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.Agreement.AgreementRoutePrices.push(...res.data.Data.ValidRoutes)
                    
                    
                }else{
                    this.Agreement.AgreementRoutePrices.push(...res.data.Data.ValidRoutes)
                    this.InvalidRoutes.push(...res.data.Data.InvalidRoutes)
                    this.NullValueRoutes.push(...res.data.Data.HasNullValueRoutes)
                }
            }).catch(err=> {
                console.err(err)
            })
        }

    },
    computed:{
        fuelBase:{
            get:function(){
                if(!this.Agreement.FuelBaseDate)
                    return null
                return this.fuelPrices.find(f => moment(f.Date).isSame(moment(this.Agreement.FuelBaseDate),'day')) || null
            },
            set:function(value){
                this.Agreement.FuelBaseDate = value == null
                    ? null
                    : moment(value.Date).format('YYYY-MM-DD')
            }
        },
        // Önizleme sonuçlarını satır sırasına göre eşleştirir.
        simulationByRow(){
            const map = {}
            if(this.simulation && this.simulation.Routes){
                this.simulation.Routes.forEach(r => {
                    map[r.RowKey] = r
                })
            }
            return map
        },
        // Modaldaki yeni rota kaydedilebilir mi? Eksik alanlar tek tek sayılır ki kullanıcı
        // hangisini atladığını görsün.
        newRouteValidationMessage(){
            const r = this.agreementRoutePrice
            const missing = []
            if(!r.StartRegionId) missing.push('başlangıç bölgesi')
            if(!r.EndRegionId) missing.push('bitiş bölgesi')
            if(!r.VehicleTypeId) missing.push('araç tipi')
            if(!r.StockCode) missing.push('ürün')
            if(!(this.parsePrice(r) > 0)) missing.push('fiyat')
            if(missing.length === 0) return null
            return 'Eksik alan: ' + missing.join(', ') + '.'
        },
        incompleteRouteIndexes(){
            return this.Agreement.AgreementRoutePrices
                .map((r,i) => this.isRouteIncomplete(r) ? i + 1 : null)
                .filter(i => i != null)
        },
        saveValidationMessage(){
            if(!this.Agreement.CariCode)
                return 'Önce cari seçmelisiniz.'
            if(this.Agreement.AgreementRoutePrices.length === 0)
                return 'En az bir rota eklemelisiniz.'

            const bad = this.incompleteRouteIndexes
            if(bad.length > 0)
                return `${bad.join(', ')}. rotada eksik bilgi var (kırmızı satırlar). `
                    + 'Bu satırları düzeltin ya da silin, aksi halde sözleşme kaydedilemez.'

            return null
        },
        cari:{
            get:function(){
                return this.cariList.find(s=>s.CARI_KOD==this.Agreement.CariCode)
            },
            set:function(value){
                this.Agreement.CariCode = value?.CARI_KOD || null
                this.Agreement.CariName = value?.CARI_ISIM || null
            }
        },
        
    }

}

</script>